module.exports = __webpack_public_path__ + "img/backyard-garden-and-planter.3c996ed9.webp";